import parse from "html-react-parser";
import { renderToStaticMarkup } from "react-dom/server";

const convertHTMLtoJSX = (str) => {
  if (!str) return null;
  const reactElements = parse(str);
  return reactElements;
};

export default convertHTMLtoJSX;
